import { render } from "./p-checkbox-group.vue?vue&type=template&id=036117ac"
import script from "./p-checkbox-group.vue?vue&type=script&lang=js"
export * from "./p-checkbox-group.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__